import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, Response } from '@tcc-mono/shared/data-access';
import { User, Stable } from '@tcc-mono/vandijk/shared/data-access/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService<User> {
  constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/users'
  }

  public getUserStables = (userId: string): Observable<Stable[]> => {
    return this.getChild<Response<Stable[]>>(userId, 'stables')
      .pipe(
        map((response: Response<Stable[]>) => response.data || [])
      );
  }

  public attachStable = (userId: string, stableId: number): Observable<unknown> => {
    return this.postChild({ stable_id: stableId }, `${userId}/stables/attach`);
  }

  public detachStable = (userId: string, stableId: number): Observable<unknown> => {
    return this.postChild({ stable_id: stableId }, `${userId}/stables/detach`);
  }

  public syncStables = (userId: string, stableIds: number[]): Observable<unknown> => {
    return this.put(userId, { stable_ids: stableIds }, 'stables/sync');
  }
}
